/* istanbul ignore file */
import './logo.css';

const Logo = () => {
  return <div className='sidebar-logo'>Logo</div>;
};

export default Logo;
